import { render, staticRenderFns } from "./WardMessageStatistics.vue?vue&type=template&id=5d7a1526&scoped=true&"
import script from "./WardMessageStatistics.vue?vue&type=script&lang=js&"
export * from "./WardMessageStatistics.vue?vue&type=script&lang=js&"
import style0 from "./WardMessageStatistics.vue?vue&type=style&index=0&id=5d7a1526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a1526",
  null
  
)

export default component.exports